import orderBy from 'lodash/orderBy';
import { PaymentMethod } from '@/core/payment-methods/interfaces';
import { PAYMENT_METHOD_ID } from '@/core/payment-methods/constants';

export function orderPaymentMethods(
    paymentMethods: Array<PaymentMethod>,
    order: Array<PAYMENT_METHOD_ID>
): Array<PaymentMethod> {
    return orderBy(paymentMethods, (paymentMethod) => {
        if (order.indexOf(paymentMethod.id) > -1) {
            return order.indexOf(paymentMethod.id);
        }

        return null;
    });
}
